export default "__VITE_ASSET__Cpnd5_3R__"